import { IComponentOptions, IController } from "angular";
import { IAssignee } from "@gtmhub/assignees";
import { IAllGoal, IAllMetric } from "@gtmhub/goals/controllers/all";
import { ContributorTypeEnum } from "@gtmhub/goals/models";
import { isContributingMetric } from "@gtmhub/okrs/metrics";
import { IdMap } from "@gtmhub/util";
import { Links } from "@webapp/links/models/links.models";

type GridContributorType = IAllGoal | IAllMetric;
export interface IOkrGridContributorAdditionalParams {
  childType: ContributorTypeEnum;
  links?: Links<"metric">;
}

export type OkrGridContributor = GridContributorType & IOkrGridContributorAdditionalParams;

const navStateByContributorType = {
  metric: `._metric.metric({'metricId': contributor.id})`,
  goal: `._goalSidebar.goal({'id': contributor.id})`,
};

export interface IOkrGridContributorsComponentBindings {
  contributors: OkrGridContributor[];
  goals: IAllGoal[];
  parent: IAllGoal;
  assigneesMap: IdMap<IAssignee>;
  deleteContributor(contributor: OkrGridContributor, goal: IAllGoal): void;
  changeAssignee(item: IAssignee, subject: GridContributorType, subjectType: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OkrGridContributorsComponentCtrl extends IOkrGridContributorsComponentBindings {}
class OkrGridContributorsComponentCtrl implements IController {
  getContributorNavState(contributor: OkrGridContributor): string {
    return navStateByContributorType[contributor.childType];
  }

  getIcon(contributor: OkrGridContributor): string {
    return contributor.childType === "goal" ? "goal" : this.getMetricIcon(contributor);
  }

  private getMetricIcon(contributor: OkrGridContributor): string {
    return isContributingMetric(contributor) ? "contributing-metric" : "metric";
  }
}

export const OkrGridContributorsComponent: IComponentOptions = {
  templateUrl: require("./okr-grid-contributors.jade"),
  controller: OkrGridContributorsComponentCtrl,
  bindings: {
    contributors: "<",
    goals: "<",
    parent: "<",
    assigneesMap: "<",
    deleteContributor: "<",
    changeAssignee: "<",
  },
};
